import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const AboutUs = () => {
  return (
    <>
      <Header />

      {/* <!--hero section start--> */}
	  
	  
	  <section class="page-title">
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-10">
        <h1>
       About Us
        </h1>
        
      </div>
    </div>
  </div>
  <div class="page-title-wave">
    <img src="./assets/images/page-bg.svg" alt="" />
  </div>
</section>
	
	  <div class="page-content">

	  <section>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12">
        <div class="shape-img-bg">
          <img class="mask-img" src="./assets/images/about/01.jpg" alt="" />
          <div class="img-bg-shape">
                      <svg  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 288 288">
              <linearGradient id="imagewave2" x1="70.711%" x2="0%" y1="70.711%" y2="0%">
                <stop class="stop-color2" offset="0%" stop-opacity="1" />
                <stop class="stop-color1" offset="100%" stop-opacity="1" />
              </linearGradient>
              <path fill="url(#imagewave2)">

                <animate  repeatCount="indefinite" attributeName="d" dur="5s"
                
                values="M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
                c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
                c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
                c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z;
                
                
                M51,171.3c-6.1-17.7-15.3-17.2-20.7-32c-8-21.9,0.7-54.6,20.7-67.1c19.5-12.3,32.8,5.5,67.7-3.4C145.2,62,145,49.9,173,43.4
                c12-2.8,41.4-9.6,60.2,6.6c19,16.4,16.7,47.5,16,57.7c-1.7,22.8-10.3,25.5-9.4,46.4c1,22.5,11.2,25.8,9.1,42.6
                c-2.2,17.6-16.3,37.5-33.5,40.8c-22,4.1-29.4-22.4-54.9-22.6c-31-0.2-40.8,39-68.3,35.7c-17.3-2-32.2-19.8-37.3-34.8
                C48.9,198.6,57.8,191,51,171.3z;
                
                M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
                c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
                c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
                c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z  "/>

                </path>

              </svg>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 mt-6 mt-lg-0 ps-lg-10">
        <div class="theme-title mb-4">
          <h6>About Us</h6>
          <h3>Fox Media </h3>
          <p>Fox Media — Qatar’s trusted partner for driving online success. We specialize in Search Engine Optimization (SEO), Geo Targeting (GEO), Answer Engine Optimization (AEO), and innovative digital marketing strategies that help your business reach the right audience, at the right time, on the right platform.<br />
<br />
Our expert team combines local market knowledge with global best practices to deliver measurable results. Whether you want to dominate Google search rankings, target customers in specific Qatar locations, or optimize for future AI-driven searches, we’ve got you covered.</p>
        </div>
        
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12 order-lg-1">
        <div class="shape-img-bg">
          <img class="mask-img" src="./assets/images/about/03.jpg" alt="" />
          <div class="img-bg-shape">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 288 288">
              <linearGradient id="imagewave2" x1="70.711%" x2="0%" y1="70.711%" y2="0%">
                <stop class="stop-color2" offset="0%" stop-opacity="1"></stop>
                <stop class="stop-color1" offset="100%" stop-opacity="1"></stop>
              </linearGradient>
              <path fill="url(#imagewave2)">

                <animate repeatCount="indefinite" attributeName="d" dur="5s" values="M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
                c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
                c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
                c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z;
                
                
                M51,171.3c-6.1-17.7-15.3-17.2-20.7-32c-8-21.9,0.7-54.6,20.7-67.1c19.5-12.3,32.8,5.5,67.7-3.4C145.2,62,145,49.9,173,43.4
                c12-2.8,41.4-9.6,60.2,6.6c19,16.4,16.7,47.5,16,57.7c-1.7,22.8-10.3,25.5-9.4,46.4c1,22.5,11.2,25.8,9.1,42.6
                c-2.2,17.6-16.3,37.5-33.5,40.8c-22,4.1-29.4-22.4-54.9-22.6c-31-0.2-40.8,39-68.3,35.7c-17.3-2-32.2-19.8-37.3-34.8
                C48.9,198.6,57.8,191,51,171.3z;
                
                M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
                c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
                c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
                c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z  "></animate>

                </path>

              </svg>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 mt-6 mt-lg-0 pe-lg-10">
        <div class="theme-title mb-4">
          <h6>Fox Media</h6>
          <h3>Why Choose Us?</h3>
          
        </div>
		  
		  <div class="row">
          <div class="col-sm-12 mb-3">
            <ul class="list-unstyled list-icon style-1">
              <li>
                <i class="flaticon flaticon-check-mark"></i>  Qatar-based Expertise – We understand the local market, audience behavior, and cultural trends.
              </li>
            </ul>
          </div>
          <div class="col-sm-12 mb-3">
            <ul class="list-unstyled list-icon style-1">
              <li>
                <i class="flaticon flaticon-check-mark"></i> Customized Strategies – No one-size-fits-all. Every campaign is designed for your brand’s unique goals.
              </li>
            </ul>
          </div>
          <div class="col-sm-12 mb-3 ">
            <ul class="list-unstyled list-icon style-1">
              <li>
                <i class="flaticon flaticon-check-mark"></i>Result-Oriented Approach – Transparent reporting, measurable ROI, and continuous optimization.
              </li>
            </ul>
          </div>
          <div class="col-sm-12 mb-3 mb-sm-0">
            <ul class="list-unstyled list-icon style-1">
              <li>
                <i class="flaticon flaticon-check-mark"></i> Latest Tech & Tools – AI-driven SEO, analytics, and automation for maximum efficiency.
              </li>
            </ul>
          </div>
			<div class="col-sm-12 mt-3 mb-sm-0">
            <ul class="list-unstyled list-icon style-1">
              <li>
                <i class="flaticon flaticon-check-mark"></i> Dedicated Support – We work as your growth partner, not just your marketing vendor.
              </li>
            </ul>
          </div>
        </div>
		  
		  
      </div>
    </div>
  </div>
</section>
		  
		  <section >
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="theme-title">
          <h6>Fox Media</h6>
          <h3>Our Services</h3>
        </div>
      </div>
    </div>
    <div class="row gx-lg-5">
      <div class="col-lg-3 col-md-6">
        <div class="step-item style-2">
          <div class="step-icon">
            <i class="flaticon flaticon-search-analysis"></i>
            <div class="step-number">01</div>
            <div class="step-icon-bg" data-bg-img="./assets/images/step-icon-bg1.png"></div>
          </div>
          <h6>SEO (Search Engine Optimization)</h6>
          <p class="mb-0">Boost your website rankings and get discovered by your ideal customers.</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 mt-6 mt-md-0">
        <div class="step-item style-2 step-bg">
          <div class="step-icon">
            <i class="flaticon flaticon-market-analysis"></i>
            <div class="step-number">02</div>
            <div class="step-icon-bg" data-bg-img="./assets/images/step-icon-bg1.png"></div>
          </div>
          <h6>AEO (Answer Engine Optimization)</h6>
          <p class="mb-0">Voice search is changing the way people find information.</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 mt-6 mt-lg-0">
        <div class="step-item style-2">
          <div class="step-icon">
            <i class="flaticon flaticon-target"></i>
            <div class="step-number">03</div>
            <div class="step-icon-bg" data-bg-img="./assets/images/step-icon-bg1.png"></div>
          </div>
          <h6>GEO (Geographical SEO)</h6>
          <p class="mb-0">Our GEO optimization ensures your business dominates local searches in Qatar.</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 mt-6 mt-lg-0">
        <div class="step-item style-2 step-bg">
          <div class="step-icon">
            <i class="flaticon flaticon-results"></i>
            <div class="step-number">04</div>
            <div class="step-icon-bg" data-bg-img="./assets/images/step-icon-bg1.png"></div>
          </div>
          <h6>Digital Marketing Solutions</h6>
          <p class="mb-0">From social media management to paid ad campaigns.</p>
			
        </div>
      </div>
    </div>
  </div>
</section>
	
	
	  
	  
	  
	
	  

        {/* <!--about end--> */}
		  
		  
      </div>
      {/* <!--body content end-->  */}

      <Footer />

      {/* <!--back-to-top start--> */}
      <div className="scroll-top">
        <svg
          className="scroll-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
      {/* <!--back-to-top end--> */}
    </>
  );
};

export default AboutUs;
